module.exports = __webpack_public_path__ + "static/img/phone-01-copy-7.8663acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/phone-01-copy-7.png
// module id = Vqdc
// module chunks = 1